export default __webpack_public_path__ + "bb0851d5c222abb13c8db0653697e563.png";